export const RESULTS_EMAIL = 'no-reply@c19testing.co.uk'
